



















import { Component, Prop, Vue } from 'vue-property-decorator'
import ButtonBase from '@/components/common/atoms/ButtonBase.vue'
import { StudentForStudyData } from '@/mixins/requests/academy/StudentForStudyApis.vue'

@Component({
  components: {
    ButtonBase,
  },
})
export default class StudentForStudyTable extends Vue {
  @Prop()
  private studentForStudyList!: StudentForStudyData[]
  @Prop()
  private onClickComfirmButton!: (bcbtCode: string) => void
}
